module.exports = __webpack_public_path__ + "static/media/leaves2.88afeeb4.png";